import React from 'react';

const SettingsIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.012 12.8302C8.40751 12.8302 7.10962 11.5802 7.10962 10.0102C7.10962 8.44018 8.40751 7.18018 10.012 7.18018C11.6165 7.18018 12.8837 8.44018 12.8837 10.0102C12.8837 11.5802 11.6165 12.8302 10.012 12.8302Z'
        fill='currentColor'
      />
      <path
        opacity='0.4'
        d='M19.23 12.37C19.0358 12.07 18.7599 11.77 18.4022 11.58C18.1161 11.44 17.9321 11.21 17.7686 10.94C17.2474 10.08 17.554 8.95 18.4227 8.44C19.4446 7.87 19.7716 6.6 19.1789 5.61L18.4942 4.43C17.9117 3.44 16.6342 3.09 15.6225 3.67C14.7232 4.15 13.5684 3.83 13.0472 2.98C12.8837 2.7 12.7917 2.4 12.8121 2.1C12.8428 1.71 12.7201 1.34 12.5362 1.04C12.1581 0.42 11.4734 0 10.7171 0H9.27614C8.53012 0.02 7.8454 0.42 7.46728 1.04C7.27311 1.34 7.16069 1.71 7.18113 2.1C7.20157 2.4 7.10959 2.7 6.94608 2.98C6.42488 3.83 5.27007 4.15 4.38097 3.67C3.35901 3.09 2.09178 3.44 1.49905 4.43L0.814337 5.61C0.231821 6.6 0.558848 7.87 1.57059 8.44C2.43925 8.95 2.74584 10.08 2.23486 10.94C2.06112 11.21 1.87717 11.44 1.59102 11.58C1.24356 11.77 0.936972 12.07 0.773459 12.37C0.395334 12.99 0.415773 13.77 0.793898 14.42L1.49905 15.62C1.87717 16.26 2.58232 16.66 3.31813 16.66C3.6656 16.66 4.07438 16.56 4.40141 16.36C4.6569 16.19 4.96348 16.13 5.30073 16.13C6.31247 16.13 7.16069 16.96 7.18113 17.95C7.18113 19.1 8.12133 20 9.3068 20H10.6967C11.8719 20 12.8121 19.1 12.8121 17.95C12.8428 16.96 13.691 16.13 14.7027 16.13C15.0298 16.13 15.3364 16.19 15.6021 16.36C15.9291 16.56 16.3277 16.66 16.6853 16.66C17.4109 16.66 18.1161 16.26 18.4942 15.62L19.2096 14.42C19.5775 13.75 19.6081 12.99 19.23 12.37Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default SettingsIcon;
